import ViewBase from '../../../../views/view-base.view';
import { messageComponent } from '../../../../components/message/message.component';
import userSearchModal from '../../../../models/common/user-search.modal';
import loginModel from '../../../../models/login.model';
import SelectUserComponent from '../../../../components/user/select-user.component';
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import MultiSelectComponent from '../../../../components/multi-select/multi-select.component';
import SelectSiteGroupComponent from '../../../../components/site/select-site-group.component';

export default function TaskTemplateUserSearchComponent() {
    ViewBase.call(this);
    let onChanged = (e) => { };
    let onAddClose = (e) => { };

    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let userRoles = [];

    let inputDataModel = {
        selectedUsers: [],
        selectedUserRoles: [],
        selectedSites: [],
        selectedSiteGroups: [],
        userText: "",
        userRoleText: "",
        siteText: "",
        siteGroupText: ""
    };

    let _enabledUserRole = false;

    let _extractInputParameters = (input) => {
        if(!input)
            return inputDataModel;

        let result = Object.assign({}, 
            _.isEmpty(input.selectedUsers) ? [] : {selectedUsers: input.selectedUsers},
            _.isEmpty(input.selectedUserRoles) ? [] : {selectedUserRoles: input.selectedUserRoles},
            _.isEmpty(input.selectedSites) ? [] : {selectedSites: input.selectedSites},
            _.isEmpty(input.selectedSiteGroups) ? [] : {selectedSiteGroups: input.selectedSiteGroups});

        result.userText = input.selectedUsers ? input.selectedUsers.map(u => u.userName).join(", ") : "";
        result.userRoleText = input.selectedUserRoles ? input.selectedUserRoles.map(r => r.name).join(", ") : "";
        result.siteText = input.selectedSites ? input.selectedSites.map(s => s.siteName).join(", ") : "";
        result.siteGroupText = input.selectedSiteGroups ? input.selectedSiteGroups.map(g => g.name).join(", ") : "";
        
        return result;
    };

    let _save = (e) => {
        let error = "";

        if (inputDataModel.siteText != "" && inputDataModel.siteGroupText != "") {
            error = this.getText("EM00000243", "Both Site and Site Group cannot be assigned!");
        } else if (inputDataModel.userRoleText != "" && inputDataModel.userText != "") {
            error = this.getText("EM00000242", "Both User and User Role cannot be assigned!");
        }

        if (error == "") {
            onChanged(inputDataModel);
        } else {
            isMsgOpen = true;
            showMsg = error;
            msgTitle = this.getText("EM00000142", "Error");
        }
    }


    let _cancel = (e) => {
        onAddClose(e);
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    let _loadUserRoleList = () => {
        userSearchModal.getUserRoleList(
            (result) => {
                userRoles = result;
            },
            (error) => {
                this.handleError(error);
            },
            loginModel.credentials.country
        )
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.onAddClose) {
                onAddClose = vnode.attrs.onAddClose;
            }

            if (vnode.attrs.enabledUserRole) {
                _enabledUserRole = vnode.attrs.enabledUserRole;
                _loadUserRoleList();
            }

            if (vnode.attrs.onChanged) {
                onChanged = vnode.attrs.onChanged;
            }
            
            inputDataModel = _extractInputParameters(vnode.attrs.searchCriteria);
        },
        view: (vnode) => {
            return [
                m('.row.col-md-12.ml-2',
                    m('.card',
                        m('.card-body',
                            m('.row.col-md-12',
                                _enabledUserRole && m('.col-md-12',
                                    m('label.form-label', this.getText("LT00000060", "User Role")),
                                    m(MultiSelectComponent, {
                                        items: userRoles,
                                        selectedItems: inputDataModel.selectedUserRoles,
                                        onSelect: (u) => {
                                            inputDataModel.selectedUserRoles = u;
                                            inputDataModel.userRoleText = u.map(r => r.name).join(', ');
                                        }
                                    })
                                ),
                                _enabledUserRole && m('.col-md-12',
                                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                                    m(SelectSiteGroupComponent, {
                                        selectedItems: inputDataModel.selectedSiteGroups,
                                        onChange: (g) => {
                                            inputDataModel.selectedSiteGroups = g;
                                            inputDataModel.siteGroupText = g.map(e => e.name).join(', ');
                                        }
                                    })
                                ),
                                _enabledUserRole && m('.col-md-12',
                                    m('label.form-label', this.getText("LT00000071", "Site")),
                                    m(SelectSiteSearchInputComponent, {
                                        multiple: true,
                                        selectedItems: inputDataModel.selectedSites,
                                        onSelect: (s) => {
                                            inputDataModel.selectedSites = s;
                                            inputDataModel.siteText = s.map(e => e.siteName).join(', ');
                                        },
                                      })
                                ),
                                _enabledUserRole && m('.col-md-12',
                                    m('label.form-label', this.getText("LT00000009", "User")),
                                    m(SelectUserComponent, {
                                        default: {
                                            userStatusCode: '0001'
                                        },
                                        onSelect: (u) => {
                                            inputDataModel.selectedUsers = u;
                                            inputDataModel.userText = u.map(e => e.userName).join(', ');
                                        },
                                        selectedUserList: inputDataModel.selectedUsers,
                                    })
                                ),
                            ),
                            (inputDataModel.userRoleText != "" || inputDataModel.siteGroupText != "" || inputDataModel.siteText != "" || inputDataModel.userText != "") && m('.col-md-12.card.mt-4',
                                m('.card-body',
                                    m(".col-12",
                                        m(".table-responsive",
                                            m("table.table", [
                                                m("thead.thead-bggrey",
                                                    m("tr.align-middle", [
                                                        m("th", { "scope": "col" }, this.getText("LT00000117", "Type")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000118", "Data")),
                                                        m("th", { "scope": "col" }, ""),
                                                    ])
                                                ),
                                                m("tbody",
                                                    inputDataModel.userRoleText != "" && m("tr",
                                                        [
                                                            m("td", this.getText("LT00000060", "User Role")),
                                                            m("td", { "style": "white-space:normal" }, inputDataModel.userRoleText),
                                                            m("td", !vnode.attrs.disabled && m('.remove_field.mt-1',
                                                                {
                                                                    onclick: e => {
                                                                        inputDataModel.userRoleText = "";
                                                                        inputDataModel.selectedUserRoles = [];
                                                                        m.redraw();
                                                                    }
                                                                },
                                                                m('span', m('i.bi.bi-dash-circle.me-0')))
                                                            ),
                                                        ]),
                                                    inputDataModel.siteGroupText != "" && m("tr",
                                                        [
                                                            m("td", this.getText("LT00000072", "Site Group")),
                                                            m("td", { "style": "white-space:normal" }, inputDataModel.siteGroupText),
                                                            m("td", !vnode.attrs.disabled && m('.remove_field.mt-1',
                                                                {
                                                                    onclick: e => {
                                                                        inputDataModel.siteGroupText = "";
                                                                        inputDataModel.selectedSiteGroups = [];
                                                                        m.redraw();
                                                                    }
                                                                },
                                                                m('span', m('i.bi.bi-dash-circle.me-0')))
                                                            ),
                                                        ]),
                                                    inputDataModel.siteText != "" && m("tr",
                                                        [
                                                            m("td", this.getText("LT00000071", "Site")),
                                                            m("td", { "style": "white-space:normal" }, inputDataModel.siteText),
                                                            m("td", !vnode.attrs.disabled && m('.remove_field.mt-1',
                                                                {
                                                                    onclick: e => {
                                                                        inputDataModel.siteText = "";
                                                                        inputDataModel.selectedSites = [];
                                                                        m.redraw();
                                                                    }
                                                                },
                                                                m('span', m('i.bi.bi-dash-circle.me-0')))
                                                            ),
                                                        ]),
                                                    inputDataModel.userText != "" && m("tr",
                                                        [
                                                            m("td", this.getText("LT00000009", "User")),
                                                            m("td", { "style": "white-space:normal" }, inputDataModel.userText),
                                                            m("td", !vnode.attrs.disabled && m('.remove_field.mt-1',
                                                                {
                                                                    onclick: e => {
                                                                        inputDataModel.userText = "";
                                                                        inputDataModel.selectedUsers = [];
                                                                        m.redraw();
                                                                    }
                                                                },
                                                                m('span', m('i.bi.bi-dash-circle.me-0')))
                                                            ),
                                                        ]
                                                    ),
                                                )
                                            ])
                                        )
                                    )
                                ),
                            )
                        ),
                        m('.card-footer',
                            m('.col-md-12 .gap-2 .d-flex .justify-content-center',
                                !vnode.attrs.disabled &&
                                m(
                                    "button.btn.btn-primary[type='button']", { onclick: _save },
                                    this.getText("LT00000022", "Save")
                                ),
                                m("button.btn.btn-white[type='button']", { onclick: _cancel },
                                    this.getText("LT00000021", "Close")
                                )
                            )
                        )
                    )
                ),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
                this.getBaseViews()];
        }
    }
}
